export class MessageRenderer {
    constructor(currentMessageComponent) {
        this.currentMessageComponent = currentMessageComponent;
    }
    draw(context) {
        // Don't render messages when game is paused
        if (context.isPaused) {
            return;
        }
        const currentMsg = this.currentMessageComponent.getCurrentMessasge();
        const ctx = context.ctx;
        const panelWidth = 640;
        const panelHeight = 50;
        const posX = (ctx.canvas.width / 2) - (panelWidth / 2);
        const posY = ctx.canvas.height - (panelHeight * 2);
        ctx.save();
        if (currentMsg) {
            // draw panels
            ctx.fillStyle = 'rgba(0, 0, 0, 0.8)';
            ctx.fillRect(posX, posY, panelWidth, panelHeight);
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
            ctx.lineWidth = 2;
            ctx.strokeRect(posX, posY, panelWidth, panelHeight);
            // draw text
            const textYOffset = 4;
            ctx.fillStyle = "white";
            ctx.font = "bold 24px 'Jersey-20', Arial";
            ctx.strokeStyle = "black";
            ctx.lineWidth = 1;
            ctx.textAlign = "center";
            ctx.fillText(currentMsg, posX + (panelWidth / 2), posY + (panelHeight / 2 + textYOffset));
        }
        ctx.restore();
    }
}
